export default {
  setCurrentPage: (state, payload) => {
    state.currentPage = payload.menu;
    state.currentMode = payload.mode;
  },

  setMenu: (state, payload) => {
    if (payload) {
      payload = payload.filter(item => item.suspended === false);
    }

    state.menu = payload;
  },

  setCurrentActiveMenu: (state, payload) => (state.currentActiveMenu = payload),

  setMenuSuspended: (state, payload) => {
    if (payload) {
      payload = payload.filter(item => item.suspended === true);
    }

    state.menuSuspended = payload;
  }
};
